import { useEffect, useState } from 'react';

const useGetApi = (url: string) => {
  const [data, setData] = useState();

  useEffect(() => {
    if (!url) return;

    fetch(url)
      .then((response) => response.json())
      .then((responseData) => setData(responseData))
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return { data };
};

export default useGetApi;
